export const formatPhoneNumber = (value: string) => {
  return `(${value.slice(0, 3)}) ${value.slice(
    3,
    6
  )}-${value.slice(6, 11)}`;
};

export const removePhoneFormat = (value: string) => {
  const stripped = value.replace(/\D/g, '');
  return /^1\d{10}/g.test(stripped) ? stripped :`1${stripped}`;
};

export const removeCountryCode = (value: string) => {
  return +value.substring(1);
};
